var _rect, _path, _line;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgOptionBCrossOut(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 43,
    height: 30,
    viewBox: "0 0 43 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 8,
    y: 1,
    width: 28,
    height: 28,
    rx: 14,
    stroke: "#272727",
    strokeWidth: 2
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.5114 20.5V8.86364H22.1705C23.0265 8.86364 23.7405 8.99053 24.3125 9.24432C24.8845 9.49811 25.3144 9.85038 25.6023 10.3011C25.8902 10.7481 26.0341 11.2633 26.0341 11.8466C26.0341 12.3011 25.9432 12.7008 25.7614 13.0455C25.5795 13.3864 25.3295 13.6667 25.0114 13.8864C24.697 14.1023 24.3371 14.2557 23.9318 14.3466V14.4602C24.375 14.4792 24.7898 14.6042 25.1761 14.8352C25.5663 15.0663 25.8826 15.3902 26.125 15.8068C26.3674 16.2197 26.4886 16.7121 26.4886 17.2841C26.4886 17.9015 26.3352 18.4527 26.0284 18.9375C25.7254 19.4186 25.2765 19.7992 24.6818 20.0795C24.0871 20.3598 23.3542 20.5 22.483 20.5H17.5114ZM19.9716 18.4886H21.9773C22.6629 18.4886 23.1629 18.358 23.4773 18.0966C23.7917 17.8314 23.9489 17.4792 23.9489 17.0398C23.9489 16.7178 23.8712 16.4337 23.7159 16.1875C23.5606 15.9413 23.339 15.7481 23.0511 15.608C22.767 15.4678 22.428 15.3977 22.0341 15.3977H19.9716V18.4886ZM19.9716 13.733H21.7955C22.1326 13.733 22.4318 13.6742 22.6932 13.5568C22.9583 13.4356 23.1667 13.2652 23.3182 13.0455C23.4735 12.8258 23.5511 12.5625 23.5511 12.2557C23.5511 11.8352 23.4015 11.4962 23.1023 11.2386C22.8068 10.9811 22.3864 10.8523 21.8409 10.8523H19.9716V13.733Z",
    fill: "#272727"
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    x1: 0.976197,
    y1: 15.0003,
    x2: 42.9762,
    y2: 14.0003,
    stroke: "#272727",
    strokeWidth: 2
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOptionBCrossOut);
export default __webpack_public_path__ + "static/media/OptionBCrossOut.75c145469b0fdddcc4a564a9786fd9b1.svg";
export { ForwardRef as ReactComponent };